export const STORE_KEY = '$home_notify';


export const SET_PARAM_LIST_NOTICATION = 'SET_PARAM_LIST_NOTICATION';